import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { useState, type ReactNode } from 'react';
import { SessionProvider } from '../modules/auth';
import { DemoProvider } from '../demo/DemoProvider';
import { Outlet } from 'react-router';
import { ApiError } from '../shared/api/apiError';

export function Providers({ children }: { children: ReactNode }) {
  const [client] = useState(() => new QueryClient({ defaultOptions: { queries: {
    retry: (count, error) => !(error instanceof ApiError && error.status < 500) && count < 1,
    refetchOnWindowFocus: false,
  } } }));
  return <QueryClientProvider client={client}>{children}</QueryClientProvider>;
}

export function OwnerProviders() { return <SessionProvider><DemoProvider><Outlet /></DemoProvider></SessionProvider>; }
